import * as ApiWithToken from "../callApiWithToken";

const apiUrl = process.env.REACT_APP_GENERAL_API_QA;

const supportService = {
  getSupportList: async function (languageId: number) {
    return ApiWithToken.getApi(
      `${apiUrl}Users/supportQuestions?languageID=${languageId}`
    );
  },
};

export default supportService;
